import { useAuth } from '@clerk/nextjs';
import { ClerkAPIError, SignOutOptions } from '@clerk/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { hasWindow } from 'utils/browser.utils';

import { Routes } from 'constants/routes.constants';
import { useAfterSignInPath } from 'hooks/useAfterSignInPath';
import { ACCOUNT_PREFIX } from 'restful/accounts/constants';

export const useSignOut = () => {
  const queryClient = useQueryClient();
  const { signOut: signOutClerk } = useAuth();
  const { replace } = useRouter();
  const { resetAfterSignInUrl } = useAfterSignInPath();

  const { mutate, isPending, error } = useMutation<
    void,
    ClerkAPIError,
    SignOutOptions
  >({
    mutationFn: signOutClerk,
    onSettled: (_res, _err, options) => {
      if (hasWindow()) {
        // clear carts
        Object.keys(localStorage)
          ?.filter((key) => key.startsWith('nf-cart'))
          ?.forEach((key) => localStorage.removeItem(key));
      }
      queryClient.removeQueries({ queryKey: [ACCOUNT_PREFIX] });
      if (options.redirectUrl) {
        replace(options.redirectUrl || Routes.Account);
        resetAfterSignInUrl();
      }
    },
  });
  return {
    signOut: mutate,
    isLoading: isPending,
    error,
  };
};
